import { getBillingClient } from '~/stores'
import type { PlanId, PlanSummary } from '../types'

export async function getNewPlanSummary(workspaceId: string, planId: PlanId): Promise<PlanSummary> {
  const plan = await getBillingClient(workspaceId).getPlan({ planId })
  return { id: planId, monthlyPriceDollars: plan.prices.month?.amount }
}
